import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './LanguageSelector.css';
import _ from 'lodash';
import Select, {components} from 'react-select';

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        ":hover": {
            backgroundColor: state.isSelected ? '#89aa11' : 'rgba(137, 170, 17, 0.44)'
        },
        backgroundColor: state.isSelected ? '#89aa11' : 'white',
        cursor: 'pointer',
        width: '60px',
        paddingTop: '0',
        paddingBottom: '0',
    }),
    control: (provided) => ({
        ...provided,
        fontSize: '.9rem',
        cursor: 'pointer',
        width: '60px',
        minHeight: '35px',
        height: '35px',
        border: '1px solid #aeb0b3',
        ":hover": {
            border: '1px solid #aeb0b3',
        },
        boxShadow: 'none'
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        padding: '0 5px 0 0'
    }),
    indicatorSeparator: () => ({
        display: 'none'
    }),
    menu: styles => ({
        ...styles,
        marginTop: '2px',
        marginBottom: '2p'
    }),
    menuList: styles => ({
        ...styles,
        paddingTop: '2px',
        paddingBottom: '2px'
    })
};

class LanguageSelector extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedLanguage: props.selectedLanguage
        }
    }

    render() {
        return <Select
            styles={customStyles}
            className="lang-select"
            isSearchable={false}
            value={_.find(this.props.languageList, lang => lang.value === this.state.selectedLanguage)}
            onChange={this.handleChange}
            components={this.getComponents()}
            options={this.props.languageList}/>;
    }

    getComponents = _ => ({
        Option: (props) => {
            return (
                <div title={props.data.title}>
                    <components.Option {...props}/>
                </div>
            );
        }
    });

    componentDidUpdate(prevProps, prevState) {
        if (prevState.selectedLanguage !== this.state.selectedLanguage) {
            this.props.onLanguageSelect(this.state.selectedLanguage);
        }
    }

    handleChange = (selectedOption) => {
        this.setState({selectedLanguage: selectedOption.value})
    };
}

LanguageSelector.propTypes = {
    className: PropTypes.string,
    selectedLanguage: PropTypes.string.isRequired,
    languageList: PropTypes.array.isRequired,
    onLanguageSelect: PropTypes.func.isRequired
};

export default LanguageSelector;



// WEBPACK FOOTER //
// ./src/components/languageSelector/LanguageSelector.js